import React, { useLayoutEffect, useRef } from 'react';
import AiCopilotChatPanel from './AiCopilotChatPanel';
import { useRightPanel } from '../app/layout/RightPanel';
import useAppSelector from '../app/redux/useAppSelector';
import { isFeatureEnabled } from '../utils/features';
import useShortcut from '../utils/useShortcut';

const AiCopilot = !isFeatureEnabled('ai_copilot')
  ? () => null
  : () => {
      const currentUser = useAppSelector((state) => state.session.user);
      const { openRightPanel, isRightPanelOpen, closeRightPanel } =
        useRightPanel();

      // TODO: Separate setting
      const isAiCopilotEnabled = currentUser.settings.aiAsk;
      const isChatPanelOpenRef = useRef(false);

      useLayoutEffect(() => {
        if (!isRightPanelOpen) {
          isChatPanelOpenRef.current = false;
        }
      }, [isRightPanelOpen]);

      useShortcut(
        'mod+option+b',
        (e) => {
          e.preventDefault();
          if (!isChatPanelOpenRef.current) {
            openRightPanel(<AiCopilotChatPanel />);
          } else {
            closeRightPanel();
          }

          isChatPanelOpenRef.current = !isChatPanelOpenRef.current;
        },
        { skip: !isAiCopilotEnabled, global: true },
      );

      return null;
    };

export default AiCopilot;
